/** @file jointsFor: the drawn puppet's joints on screen this frame (empty before the first bundle). */
import { jointFracsOf } from './jointFracsOf';
import type { ScreenJoint } from './projectJoints';
import { projectJoints } from './projectJoints';
import type { ViewportCtx } from './viewportCtx';

/** `projectJoints` of the instance's last pose under the viewport camera's view, placed where the bone marks draw them. */
export function jointsFor(ctx: ViewportCtx): ScreenJoint[] {
  const p = ctx.puppet();
  if (p === null || ctx.scene === null) return [];
  const fracs = ctx.profile === null ? undefined : jointFracsOf(p, ctx.profile);
  return projectJoints(p.instance.state().pose, p.source.puppet, ctx.scene.camera.view(), [0, 0, 0], fracs);
}
